import { alpha, Box, colors, styled, tablePaginationClasses } from '@mui/material'

export const tableGridClasses = {
  root: 'TableGrid-root',
  content: 'TableGrid-content',
  contentPosition: 'TableGrid-contentPosition',
  contentInner: 'TableGrid-contentInner',
  filterBarWrap: 'TableGrid-filterBarWrap',
  loading: 'TableGrid-loading',
  overlay: 'TableGrid-overlay',
  item: 'TableGrid-item',
  actions: 'TableGrid-actions',
  noItems: 'TableGrid-noItems'
}

export const TableGridStyled = styled(Box)(({ theme }) => ({
  flex: 1,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  [`.${tableGridClasses.content}`]: {
    position: 'relative',
    flex: 1,
    zIndex: 1
  },
  [`.${tableGridClasses.contentPosition}`]: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  [`.${tableGridClasses.contentInner}`]: {
    overflowY: 'auto',
    padding: '10px 5px'
  },
  [`.${tableGridClasses.filterBarWrap}`]: {
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    alignItems: 'stretch',
    flexDirection: 'row'
  },
  [`.${tableGridClasses.overlay}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: alpha(colors.common.white, 0.4),
    zIndex: 10
  },
  [`.${tableGridClasses.noItems}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  [`.${tableGridClasses.item}`]: {
    position: 'relative'
  },
  [`.${tableGridClasses.actions}`]: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    zIndex: 5,
    display: 'inline-block'
  },
  [`.${tablePaginationClasses.root}`]: {
    background: colors.common.white,
    position: 'relative',
    zIndex: 5
  }
}))

export const ItemDefault = styled(Box)({
  width: '100%',
  paddingBottom: '100%',
  background: colors.grey[600]
})
